<template>
  <div>
    <div class="title_box1_training">
    </div>
    <div class="liveBox">
      <div class="liveMain">
        <div class="title">
          <div class="liveName">{{title}}</div>
          <div class="status">
<!--            <div class="time">直播计时{{ time.minute }}:{{ time.second }}</div>-->
<!--            <button type="button" @click="quitRoom">退出直播</button>-->
          </div>
        </div>
        <div class="main">
          <div class="workArea">
            <div class="live_video" id="live_video"></div>
          </div>
        </div>

        <div class="comment">
          <div class="comment_title">评论<span>（{{ commitList.length }}条）</span></div>
          <ul>
            <li v-for="todo in commitList" :key="todo.date">
              <div class="name">{{ todo.nick }}</div>
              <div class="text">{{ todo.text }}</div>
              <div class="time">{{ todo.date }}</div>
            </li>
          </ul>
          <div class="commit_footer">
            <div class="upCommit">
              <input v-model="commit" type="text" placeholder="请输入评论">
              <button :class="{stop: Number(isBan) === 1}" :disabled="Number(isBan) === 1" @click="submitCommit">发布</button>
            </div>
          </div>
        </div>
      </div>

      <el-dialog class="resetDialog liveEndDialog" title="直播已结束" width="500px" :visible.sync="liveStatusVisible">
        <div slot="title"></div>
        <div class="live_end">
          <h6>{{ liveErrorText || "直播已结束，是否退出直播？" }}</h6>
          <div class="live_endBtns">
            <button v-show="!liveErrorText" type="button" @click="liveStatusVisible = false">取消</button>
            <button class="live_endQuit" type="button" @click="quitLive">退出直播</button>
          </div>
        </div>
        <div slot="footer"></div>
      </el-dialog>
      <div id="whiteboard" style="width:1px;height:1px; opacity: 0;"></div>
    </div>
  </div>
</template>
<script>
import TIM from "tim-js-sdk";
import IM from "@/components/IM/im.js";
window.TIM = TIM;
import { queryStreamByStreamName } from "network/live";
import { checkCoursePermission, newLiveStatus } from "network/livePc"
import { genTestUserSig } from "./../../../public/debug/GenerateTestUserSig";
import TRTC from 'trtc-js-sdk'
const TEduBoard = window.TEduBoard;
window.TRTC = TRTC;
import Cookies from "js-cookie";
import {getNews} from "../../network/LPersonal";
export default {
  data() {
    return {
      time: {
        count: 0,
        second: "00",
        minute: "00"
      },
      commit: "",
      tim: null,
      isBan: 2,
      liveStatusVisible: false,
      intervalCount: null,
      userID: null,
      commitList: [],
      courseId: null,
      imReady: false,
      liveErrorText: "",
      sdkAppId: 1400557229,
      roomId: null,

      projectId: null,
      title: '',
      userInfo: {},
      userName: ''
    };
  },
  mounted() {
    console.error("测试", this.$route.query);
    this.roomId = Number(this.$route.query.id);
    this.projectId = this.$route.query.projectId;
    this.courseId = this.$route.query.course;
    this.title = this.$route.query.name;
    this.userID = this.Get("userId");
    console.error('this.userID===', this.userID)
    // const video = document.querySelector(".live_video");
    // this.playVideo(`stream_${this.roomId}_001`, "live_video", video.offsetWidth, video.offsetHeight);
    // this.joinRoom();
    this.getUserInfo()
    this.joinLive();
  },
  deactivated() {
    this.quitRoom();
  },
  methods: {
    getUserInfo() { // 获取用户信息
      getNews({
        userId: Cookies.get(`admin-userId`)
      }).then((res) => {
        this.userInfo = res.data.data.user
        this.userName = this.userInfo.fullName ? this.userInfo.fullName : this.userInfo.mobile.replace(/^(\d{3})\d{4}(\d+)/, "$1****$2")
      });
    },
    quitLive() { // 退出直播
      this.$router.go(-1);
      this.liveStatusVisible = false;
      console.error('退出直播===', this.liveStatusVisible)
    },

    editReady() {
      this.imReady = true;
      console.error("状态改为ready");
    },
    joinLive() { // 加入直播间
      const video = document.querySelector(".live_video");
      this.playVideo(`stream_${this.roomId}`, "live_video", video.offsetWidth, video.offsetHeight);
      this.joinRoom();
      this.timeCount();
      // checkCoursePermission(this.courseId).then(res => {
      //   if(res.data.data.isSingUp) {
      //     const video = document.querySelector(".live_video");
      //     this.playVideo(`stream_${this.roomId}_001`, "live_video", video.offsetWidth, video.offsetHeight);
      //     this.joinRoom();
      //     this.timeCount();
      //   }
      // })
    },
    submitCommit() { // 发送评论
      this.setMessage({
        type: "t5",
        data: {
          text: this.commit
        }
      });
      this.commit = "";
    },

    banUser(data) { // 禁言用户
      console.error("禁言操作", data);
      this.isBan = data.type;
    },
    setMessage(json, callback) { // 发送消息
      if (!this.tim) return;
      console.error("发消息：", JSON.stringify(json));
      return this.tim.sendGroupTextMessage({text: JSON.stringify(json)}).then(res => {
        console.error("消息发出去了：", res);
        callback && callback(res);
      })
    },
    timeCount() { // 直播计时
      clearTimeout(this.intervalCount);
      this.intervalCount = setInterval(()=>{
        this.time.count += 1;
        const count = this.time.count;
        const second = count%60;
        const minute = Math.floor(count/60);
        this.time.second = String(second).padStart(2, "0");
        this.time.minute = String(minute).padStart(2, "0");
      }, 1000);
    },
    joinRoom() { // 加入IM群组
      console.log('加入IM群组==', this.userID);
      // this.whiteboardStream(this.userID);
      this.tim = new IM({
          roomId: this.roomId,
          name: String(this.roomId),
          sdkId: this.sdkAppId
      });
      this.tim.login(String(this.userID)).then(res => {
          console.error("登录成功：", res);
          this.tim.Tim.updateMyProfile({
              nick: this.userName,
              role: 3,
              gender: this.userInfo.gender === 1 ? window.TIM.TYPES.GENDER_MALE : this.userInfo.gender === 2 ? window.TIM.TYPES.GENDER_MALE : window.TIM.TYPES.GENDER_UNKNOWN
          });
          this.createRoom();
      });
    },
    createRoom() { // 创建房间并加入房间 （创建已创建则加入）
        this.tim.createRoom().then(res => {
            console.error("im连接成功：", res);
            this.addTICMessageListener();
        });
    },
    addTICMessageListener() { // 增加IM消息监听回调
      console.error("触发监听");
      this.tim.on(window.TIM.EVENT.MESSAGE_RECEIVED, (e) => {
          const msg = e.data[0];
          const data = JSON.parse(msg.payload.text);
          console.error("收到消息", data);
          switch (data.type) {
              case 1: // 有人加入直播间
                  break;
              case 2: // 有人离开直播间
                this.quitRoom();
                break;
              case 3: // 为禁言 解禁
                if (Number(data.data.id) === Number(this.userID)) this.banUser(data.data);
                break;
              case 4: // 踢人
                if (Number(data.data.id) === Number(this.userID)) {
                  this.liveErrorText = "您已被踢出直播间";
                  this.liveStatusVisible = true;
                  this.quitRoom(true);
                }
                break;
              case 5: // 发言
                this.commitList.unshift(data.data);
                break;
              case 6: // 结束直播
                  break;
          }
      });
    },
    quitRoom(status) { // 退出房间
      /*if(!this.tic) {
        this.$router.go(-1);
        return;
      }*/
      console.log("触发退出");
      // this.tim.off(window.TIM.EVENT.SDK_READY, this.editReady);
      this.tim.Tim.quitGroup(String(this.roomId));
      this.tim.logout();
      if (status) { // 踢出直播间
        setTimeout(() => {
          this.liveStatusVisible = false;
          this.$router.go(-1);
        }, 2000);
      }
    },

    addTICEventListener() { // 事件监听回调
      this.tic.addTICEventListener({
        onTICMemberJoin: (members) => {
          console.error(members);
          console.error("群消息", members.join(",") + "进入课堂");
          const userId = Number(members.join(","));
          console.error(userId, this.UserID);
          if (userId === this.UserID) {
            this.sendGroupTextMessage(JSON.stringify({
              type: 1,
              data: {
                name: "测试名称",
                type: 3 // 1为老师，2为助教，3为学员
              }
            }));
          }
        },

        onTICMemberQuit: (members) => {
          console.error("群消息", members.join(",") + "退出课堂");
        },

        onTICClassroomDestroy: () => {
          this.quitClassroom();
          console.error(`老师解散了课堂`);
        },

        onTICTrtcClientCreated: () => {
          console.error(`trtcclient创建成功`);
          // window.trtcClient = this.trtcClient = this.tic.getTrtcClient();
          // this.initTRTCEvent();
        }
      });
    },
    addTICStatusListener() { // IM状态监听回调
      this.tic.addTICStatusListener({
        onTICForceOffline: (event) => {
          if (event.data) {
            if (event.data.type) {
              if (event.data.type === window.TIM.TYPES.KICKED_OUT_MULT_ACCOUNT) {
                console.error(`同一账号，多页面登录被踢`);
              } else if (event.data.type === window.TIM.TYPES.KICKED_OUT_MULT_DEVICE) {
                console.error(`同一账号，多端登录被踢`);
              } else if (event.data.type === window.TIM.TYPES.KICKED_OUT_USERSIG_EXPIRED) {
                console.error(`userSig过期`);
              } else {
                console.error(`帐号其他地方登录，被T了`);
              }
            } else {
              console.error(`帐号其他地方登录，被T了`);
            }
          } else {
            console.error(`帐号其他地方登录，被T了`);
          }
        }
      });
    },

    whiteboardStream(id) { // 初始化IM
      this.tic = new window.TIC({});
      console.log(' this.tic====',  this.tic);
      this.tic.init(this.sdkAppId, res => {
        if (res.code) {
          console.error('初始化失败，code:' + res.code + ' msg:' + res.desc);
        } else {
          this.tim = this.tic.getImInstance(); //获取im实例
          // 监听im的状态，如果不是ready状态，创建群，加群，发消息等操作都会失败
          // 监听的im的事件，一定要调用off注销，否则会出现重复监听的问题
          this.tim.on(window.TIM.EVENT.SDK_READY, this.editReady);
          this.loginUser(id);
        }
      })
    },
    loginUser(id) { // 登录至IM
      const { userSig, userId } = this.getSig(id);
      this.tic.login({
        userId: userId,
        userSig: userSig
      }, (res) => {
        if (res.code) {
          console.error("登录失败", res, res.code);
        } else {
          setTimeout(() => {
            this.tim.getGroupMemberProfile({
              groupID: String(this.roomId),
              userIDList: [this.userID]
            }).then(res => {
              console.error('登录至IM', res);
              if (res.data.memberList.length === 1) {
                this.isBan = res.data.memberList[0].muteUntil * 1000 > Date.now() ? "1" : "2";
              }
            });
            this.tim.updateMyProfile({
              nick: this.userName,
              role: 3,
              gender: this.userInfo.gender === 1 ? window.TIM.TYPES.GENDER_MALE : this.userInfo.gender === 2 ? window.TIM.TYPES.GENDER_MALE : window.TIM.TYPES.GENDER_UNKNOWN
              // profileCustomField: [
              //     {
              //         key: "Tag_Profile_Custom_Ban",
              //         value: "2"
              //     }
              // ]
            });
            this.joinClassroom(); // 直接加入
          }, 2000);
        }
      });
    },
    joinClassroom() { // 加入房间
        console.error(' 加入房间',this.imReady, this.roomId);
      if(!this.imReady) return;
      this.tic.joinClassroom({classId: this.roomId}, { mode: window.TIC.CONSTANT.TICRoleType.TIC_ROLE_TYPE_AUDIENCE }, {
        id: 'whiteboard',
        ratio: '16:9',
        smoothLevel: 0,
        boardContentFitMode: 1,
        toolType: 1,
        progressEnable: true,
        progressBarUrl: 'https://resources-tiw.qcloudtrtc.com/board/icons/Gear-0.2s-48px.png'
      }, res => {
        if (res.code) {
          console.error('加入课堂失败');
          console.error(res);
        } else {
          console.error('加入课堂成功', res);
          // window.teduBoard = this.teduBoard = this.tic.getBoardInstance();
          this.setMessage({
            type: 1,
            data: {
              id: this.userID,
              name: this.userName,
              type: 1
            }
          });
          this.addTICMessageListener();
          this.addTICEventListener();
          this.addTICStatusListener();
          this.initBoardEvent();
          // this.StartWhiteboardPush();
        }
      });
    },
    getSig(id) { // 获取Sig
      const userSig = genTestUserSig(id).userSig;
      return {
        userSig,
        userId: id
      }
    },
    playVideo(streamName, id, width, height) { // 查询混流后的播放地址
      console.error("配置：", streamName, id, width, height)
     new window.TcPlayer(id, {
          "webrtc": `webrtc://mplay.yfhpgm.cn/live/${streamName}`,
          "autoplay": true, // iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
          "poster": "http://www.test.com/myimage.jpg",
          "live": true,
          "width": width, // 视频的显示宽度，请尽量使用视频分辨率宽度
          "height": height, // 视频的显示高度，请尽量使用视频分辨率高度
          "listener": (msg) => {
              if (msg.type === "error") {
                  this.liveErrorText = "直播异常，是否退出直播？";
                  this.liveStatusVisible = true;
                  clearInterval(this.times);
                  return;
              }
              if (!this.times) {
                  clearInterval(this.times);
              }
          }
      });
    },
    newLiveStatus(Action) { // 传输用户状态
      newLiveStatus({
        Action,
        ClassNo: this.roomId,
        Operator: this.userID,
        projectId: this.projectId,
        totalusernum: 0
      })
    },
    Get(name) {
      return Cookies.get(`admin-${name}`);
    }
  },
  beforeDestroy() {
    this.newLiveStatus(107);
  }
};
</script>
<style lang="less" scoped>
.liveBox{
  width: 1200px;
  margin:20px auto 30px;
}
.liveMain{
  padding:0 12px;
  background: #fff;
  .title{
    width: 1200px;
    background: #000000;
    opacity: 0.8;
    font-size: 16px;
    font-weight: bold;
    color: #ffffff;
    z-index: 99;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 48px;
    line-height: 48px;
    padding: 0 10px;
    box-sizing: border-box;

    .liveName{
      font-size: 18px;
      color: #ffffff;
      font-weight: bold;
    }
    .status{
      display: flex;
      align-items: center;
      .time{
        color: #ffffff;
        font-size: 14px;
        padding-right: 20px;
      }
      button{
        width: 84px;
        height: 28px;
        line-height: 28px;
        color: #fff;
        border: none;
        border-radius: 28px;
        text-align: center;
        font-size: 14px;
        background: #FFAB56;
        cursor: pointer;
      }
    }
  }
  .main{
    display: flex;
    width: 1200px;
    overflow: hidden;
    .workArea{
      width: 1200px;
      height: 692px;
      position: relative;
      background: #F8F8F8;
      .live_video{
        width: 100%;
        height: 100%;
        background: url(https://medoss.oss-cn-shanghai.aliyuncs.com/education/08e1606a7cdf11eda203acde48001122.png);
        background-size: 100% 100%;
      }
    }
    .live_right{
      .webcamStream{
        width: 280px;
        height: 280px;
        background: #ccc;
      }
      .userList{
        ul{
          li{
            .userName{

            }
          }
        }
      }
    }
  }

  .comment{
    padding:20px 22px 0 41px;
    .comment_title{
      color: #319EFF;
      font-size: 17px;
      margin-bottom: 37px;
      font-weight: bold;
      span{
        font-size: 15px;
        font-weight: normal;
        color: #666666;
      }
    }
    ul{
      height: 380px;
      overflow: auto;
      li{
        margin-bottom: 30px;
        .name{
          color: #333;
          font-size: 17px;
          font-weight: bold;
        }
        .text{
          color: #666666;
          font-size: 15px;
          padding: 10px 0 12px;
        }
        .time{
          color: #666666;
          font-size: 15px;
        }
      }
    }
    .commit_footer{
      height: 124px;
      display: flex;
      align-items: center;
      justify-content: center;
      .upCommit{
        width: 797px;
        height: 56px;
        display: flex;
        border: 1px solid #319EFF;
        border-radius: 10px;
        overflow: hidden;
        input{
          width: 690px;
          //box-sizing: border-box;
          padding-left: 21px;
          height: 100%;
          font-size: 17px;
        }
        input::placeholder{
          color:#BEBEBE ;
        }
        button{
          width: 107px;
          height: 100%;
          background: #319EFF;
          font-size: 17px;
          color: #fff;
          text-align: center;
          line-height: 56px;
          font-weight: bold;
          cursor: pointer;
        }
        button.stop{
          background: #ccc;
        }
      }
    }
  }
}

.live_end{
  text-align: center;
  padding-bottom: 72px;
  h6{
    font-size: 24px;
    color: #000;
    line-height: 30px;
    padding:115px 0 50px;
  }
  .live_endBtns{
    button{
      background: none;
      width: 180px;
      height: 58px;
      border: 1px solid #319EFF;
      border-radius: 58px;
      text-align: center;
      line-height: 58px;
      color: #319EFF;
      font-size: 16px;
      cursor: pointer;
    }
    .live_endQuit{
      background: #319EFF;
      color: #fff;
      margin: 0 10px;
    }
  }
}
</style>